export default __webpack_public_path__ + "static/media/feature-icon-01.9c67b4a0.svg";